export const supportedVideoFormats = ["video/webm", "video/mp4", "video/ogg"];

export const supportedFileFormats = ["image/*", ...supportedVideoFormats];

export const uploadSizeLimitInBytes = 256 * 1024 * 1024;

export const minimumImagesCount = 3;

export const minimumCaseTitleLength = 15;

export const minimumCaseDescriptionLength = 140;

export const caseTitleErrorMessage = `Case title must be at least ${minimumCaseTitleLength} characters`;

export const caseDescriptionErrorMessage = `Case description must be at least ${minimumCaseDescriptionLength} characters`;

export const caseDescriptionHelperMessage =
  "Type the patient medical history, chief complaint, treatment plan and tools used";

export const minimumImagesWarningMessage = "We recommend that you add more photos to the case to be well documented.";

export const missingCaptionsWarningMessage = "Some photos are without captions, do you want to keep them this way?";

export const warningConfirmButtonText = "Publish";

export const minimumImagesWarningCancelButtonText = "Add Photos";

export const missingCaptionsWarningCancelButtonText = "Keep Editing";



// WEBPACK FOOTER //
// ./src/scenes/NewCase/constants.js